import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=d2ef4414&scoped=true&"
import script from "./Price.vue?vue&type=script&lang=ts&"
export * from "./Price.vue?vue&type=script&lang=ts&"
import style0 from "./Price.vue?vue&type=style&index=0&id=d2ef4414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ef4414",
  null
  
)

export default component.exports